import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'p-key-value-viewer',
    template: `<div *ngFor="let item of values | keyvalue" fxLayout="row" fxLayoutGap="10px" style="margin-top:15px;">
        <div class="ellipsis" [title]="item.key" style="max-width: 500px; ">{{ item.key }}:</div>
        <div class="ellipsis" style="max-width: 500px;" [title]="item.value">{{ item.value }}</div>
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PKeyValueViewerComponent {
    @Input() values: Record<string, unknown> = {};
}
